import React from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Transition, Dimmer, Loader, Message } from 'semantic-ui-react';
import { setUserSubscriptionLevelByCode } from '@emyw/subscribe-lib/utils';
import { log } from '@emyw/core-lib';
import Step2CreateAccount from '@emyw/subscribe-lib/Step2CreateAccount';
import { ValidateStep, subscriptionProgress } from './index';
import { loadUser } from '../actions/userActions';
import { withAppContext } from '../AppContext';

const { REACT_APP_TOKEN_NAME, REACT_APP_REFRESH_TOKEN_NAME, REACT_APP_ENJOY_SITE_ROOT_URL } = process.env;

class NewAccount extends React.Component {
    state = {
        proceedTo: undefined,
        processing: false,
        error: undefined,
    };

    componentWillMount() {
        const { context } = this.props;
        const { user } = context.state;
        ValidateStep(window.location, user).then((directTo) => {
            if (directTo === 'newaccount') return;
            const { skipPlanSelect } = context.state;
            if (directTo === 'plan' && skipPlanSelect) return;
            this.setState({ proceedTo: directTo });
        });
        context.setAppState({ currentStep: 'account' });
    }

    setNextLocation = (pathname) => {
        localStorage.setItem('enjoy-signup-progress', pathname);
        this.setState({ proceedTo: pathname });
    }

    updateSubscriptionLevel = async (userId, planCode) => {
        try {
            const result = await setUserSubscriptionLevelByCode(userId, planCode);
            const { ok, errors } = result;
            if (ok) {
                return true;
            }
            this.setState({ error: errors[0].message, processing: false });
            return false;
        } catch (error) {
            log.trace(error);
            this.setState({ error: error.message, processing: false });
        }
        return false;
    };

    saveFormValues = (values) => {
        // log.trace('values:', values);
        if (values !== null) {
            sessionStorage.setItem('user-form-values', JSON.stringify(values).replace(/("password(Confirm)?"):"[^"]+"/g, '$1:"*******"'));
            return true;
        }
        return false;
    }

    handleFormSubmittedPendingValidation = (values) => {
        this.saveFormValues(values);
    }

    handleFormComplete = (values) => {
        const { context } = this.props;
        log.trace('handleFormComplete', values);
        if (this.saveFormValues(values)) {
            /* New user about to be validated so remove any previous enjoy tokens and reset App user to null */
            localStorage.removeItem(REACT_APP_TOKEN_NAME);
            localStorage.removeItem(REACT_APP_REFRESH_TOKEN_NAME);
            loadUser('network-only')(({ user }) => {
                context.setAppState({ user });
                this.setNextLocation('verifyaccount');
            });
        } else {
            /** If we have null on values then attempt to load the user state from authentication tokens
             * presuming that the registration actually authenticated the user in one step
             * */
            loadUser('network-only')(({ user }) => {
                // if (user.verifiedOn) {
                // Remove unneeded storage items; will get progress from user object now instead
                sessionStorage.removeItem('user-form-values');
                sessionStorage.removeItem('social-user');
                localStorage.removeItem('verification-email');
                localStorage.removeItem('enjoy-signup-progress');
                localStorage.removeItem('plan-code');
                // }
                if (user.signupCompletedOn) {
                    /** At this point, if user signup is completed, credentials for an existing and completed user
                     * were entered, so redirect to home page
                     */
                    // this.setState({ proceedTo: '/' });
                    window.location.href = REACT_APP_ENJOY_SITE_ROOT_URL;
                } else {
                    // if (user.verifiedOn)
                    context.setAppState({ user });
                    this.setState({ proceedTo: subscriptionProgress(user) });
                }
            });
        }
    }

    handleTermsClick = () => {
        const { context } = this.props;
        context.setAppState({ termsModalOpen: true });
    }

    handlePrivacyClick = () => {
        const { context } = this.props;
        context.setAppState({ policyModalOpen: true });
    }

    render() {
        const { context } = this.props;
        const { disableSocialLogin, skipPlanSelect } = context.state;
        const { proceedTo, processing, error } = this.state;
        // For redirect, only push if disableSocialLogin is true (SetupAccount page was skipped),
        // otherwise SetupAccount page already pushed it's route
        if (proceedTo) return <Redirect push={disableSocialLogin} to={`/${proceedTo === '/' ? '' : `signup/${proceedTo}`}`} />;
        let { user } = context.state;
        if (user && Object.keys(user).length === 0) user = undefined;
        const socialUser = JSON.parse(sessionStorage.getItem('social-user'));
        const userFormValues = JSON.parse(sessionStorage.getItem('user-form-values'));
        log.trace('userFormValues', userFormValues);
        const planCode = localStorage.getItem('plan-code');
        return (
            <div style={{ margin: '0 auto' }}>
                <Helmet>
                    <title>Enjoy Signup - Create Account</title>
                    <meta name="description" content="Create account" />
                </Helmet>
                {processing && (
                    <Transition visible={processing} animation="scale" duration={500}>
                        <Dimmer active/* inverted */>
                            {/* eslint-disable-next-line react/jsx-tag-spacing */}
                            <Loader /* inverted */>One Moment...</Loader>
                        </Dimmer>
                    </Transition>
                )}
                <Step2CreateAccount
                    user={user || userFormValues}
                    socialNetworkUser={socialUser}
                    planCode={planCode}
                    onFormComplete={this.handleFormComplete}
                    onFormSubmittedPendingValidation={this.handleFormSubmittedPendingValidation}
                    onTermsClick={this.handleTermsClick}
                    onPrivacyClick={this.handlePrivacyClick}
                    planSelectDisabled={skipPlanSelect}
                    darkMode
                />
                {error ? (
                    <Message
                        size="small"
                        error
                        header="Trouble with registration form..."
                        content={error}
                    />
                ) : null}
            </div>
        );
    }
}

export default withAppContext(NewAccount);
